import OrdersScreen from "@/UI/screens/OrdersScreen";

export default function OrdersRoute() {
    return <OrdersScreen />;
}
